import axios from 'axios';
import { get } from 'lodash-es';
import { ofType, StateObservable } from 'redux-observable';
import { from, Observable as ActionsObservable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { RootState } from '../../reducers';
import { ActionType } from '../../constants/redux';
import {
	CODEAPI,
	LOGINAPI,
	PINAPI,
	PRECHECKAPI,
	RESENDOTP,
	VALIDATEOTP,
	FORGOT_PIN,
	ACCEPT_TNC
} from '../../constants/urls';
import {
	AcceptTNC,
	LoginUser,
	LoginUserPayload,
	NavigateCode,
	PinPayload,
	PreCheckUser,
	PreCheckUserPayload,
	ResendOTP,
	ResendOtpPayload,
	SetupPin,
	TNCPayload,
	ValidateEmail,
	ValidateOtp,
	ValidateOtpPayload
} from './types';

export const PreCheckEpic = (
	action$: ActionsObservable<ActionType>,
	rootState$: StateObservable<RootState>
) =>
	action$.pipe(
		ofType(PreCheckUser.name),
		mergeMap((action) => {
			const body = action.payload as PreCheckUserPayload;
			const clientId = get(rootState$.value, 'home.clientId', '');
			const captchaToken = get(rootState$.value, 'login.captchaToken', '');
			const nextView = get(rootState$.value, 'login.nextView', '');
			return from(
				axios({
					url: `${PRECHECKAPI}?client_id=${clientId}`,
					method: 'POST',
					data: body,
					headers: {
						'Content-Type': 'application/json',
						'X-Recaptcha-Token': captchaToken,
						Action: nextView
					}
				})
			).pipe(
				map((response: any) => PreCheckUser.successAction(response, action)),
				catchError((error: any) => of(PreCheckUser.failureAction(error, action)))
			);
		})
	);

export const LoginEpic = (
	action$: ActionsObservable<ActionType>,
	rootState$: StateObservable<RootState>
) =>
	action$.pipe(
		ofType(LoginUser.name),
		mergeMap((action) => {
			const body = action.payload as LoginUserPayload;
			const clientId = get(rootState$.value, 'home.clientId', '');
			const captchaToken = get(rootState$.value, 'login.captchaToken', '');
			const nextView = get(rootState$.value, 'login.nextView', '');
			return from(
				axios({
					url: `${LOGINAPI}?client_id=${clientId}`,
					method: 'POST',
					data: body,
					headers: {
						'Content-Type': 'application/json',
						'X-Recaptcha-Token': captchaToken,
						Action: nextView
					}
				})
			).pipe(
				map((response: any) => LoginUser.successAction(response, action)),
				catchError((error: any) => of(LoginUser.failureAction(error, action)))
			);
		})
	);

export const ValidateOtpEpic = (
	action$: ActionsObservable<ActionType>,
	rootState$: StateObservable<RootState>
) =>
	action$.pipe(
		ofType(ValidateOtp.name),
		mergeMap((action) => {
			const body = action.payload as ValidateOtpPayload;
			const clientId = get(rootState$.value, 'home.clientId', '');
			const captchaToken = get(rootState$.value, 'login.captchaToken', '');
			const nextView = get(rootState$.value, 'login.nextView', '');
			return from(
				axios({
					url: `${VALIDATEOTP}?client_id=${clientId}`,
					method: 'POST',
					data: body,
					headers: {
						'Content-Type': 'application/json',
						'X-Recaptcha-Token': captchaToken,
						Action: nextView
					}
				})
			).pipe(
				map((response: any) => ValidateOtp.successAction(response, action)),
				catchError((error: any) => of(ValidateOtp.failureAction(error, action)))
			);
		})
	);

export const ResendOtpEpic = (
	action$: ActionsObservable<ActionType>,
	rootState$: StateObservable<RootState>
) =>
	action$.pipe(
		ofType(ResendOTP.name),
		mergeMap((action) => {
			const body = action.payload as ResendOtpPayload;
			const clientId = get(rootState$.value, 'home.clientId', '');
			const captchaToken = get(rootState$.value, 'login.captchaToken', '');
			const nextView = get(rootState$.value, 'login.nextView', '');
			return from(
				axios({
					url: `${RESENDOTP}?client_id=${clientId}`,
					method: 'POST',
					data: body,
					headers: {
						'Content-Type': 'application/json',
						'X-Recaptcha-Token': captchaToken,
						Action: nextView
					}
				})
			).pipe(
				map((response: any) => ResendOTP.successAction(response, action)),
				catchError((error: any) => of(ResendOTP.failureAction(error, action)))
			);
		})
	);

export const PinEpic = (
	action$: ActionsObservable<ActionType>,
	rootState$: StateObservable<RootState>
) =>
	action$.pipe(
		ofType(SetupPin.name),
		mergeMap((action) => {
			const body = action.payload as PinPayload;
			const method = body.method;
			const clientId = get(rootState$.value, 'home.clientId', '');
			const captchaToken = get(rootState$.value, 'login.captchaToken', '');
			const nextView = get(rootState$.value, 'login.nextView', '');
			return from(
				axios({
					url: `${PINAPI}?client_id=${clientId}`,
					method: method === 'POST' ? 'POST' : 'PUT',
					data: { nonce: body.nonce, pin: body.pin },
					headers: {
						'Content-Type': 'application/json',
						'X-Recaptcha-Token': captchaToken,
						Action: nextView
					}
				})
			).pipe(
				map((response: any) => SetupPin.successAction(response, action)),
				catchError((error: any) => of(SetupPin.failureAction(error, action)))
			);
		})
	);

export const TNCEpic = (
	action$: ActionsObservable<ActionType>,
	rootState$: StateObservable<RootState>
) =>
	action$.pipe(
		ofType(AcceptTNC.name),
		mergeMap((action) => {
			const body = action.payload as TNCPayload;
			const clientId = get(rootState$.value, 'home.clientId', '');
			const captchaToken = get(rootState$.value, 'login.captchaToken', '');
			const nextView = get(rootState$.value, 'login.nextView', '');
			return from(
				axios({
					url: `${ACCEPT_TNC}?client_id=${clientId}`,
					method: 'POST',
					data: { nonce: body.nonce, action: body.action },
					headers: {
						'Content-Type': 'application/json',
						'X-Recaptcha-Token': captchaToken,
						Action: nextView
					}
				})
			).pipe(
				map((response: any) => AcceptTNC.successAction(response, action)),
				catchError((error: any) => of(AcceptTNC.failureAction(error, action)))
			);
		})
	);

export const NavigateCodeEpic = (
	action$: ActionsObservable<ActionType>,
	rootState$: StateObservable<RootState>
) =>
	action$.pipe(
		ofType(NavigateCode.name),
		mergeMap((action) => {
			const body = action.payload as ResendOtpPayload;
			const clientId = get(rootState$.value, 'home.clientId', '');
			const captchaToken = get(rootState$.value, 'login.captchaToken', '');
			const nextView = get(rootState$.value, 'login.nextView', '');
			return from(
				axios({
					url: `${CODEAPI}?client_id=${clientId}`,
					method: 'POST',
					data: body,
					headers: {
						'Content-Type': 'application/json',
						'X-Recaptcha-Token': captchaToken,
						Action: nextView
					}
				})
			).pipe(
				map((response: any) => NavigateCode.successAction(response, action)),
				catchError((error: any) => of(NavigateCode.failureAction(error, action)))
			);
		})
	);

export const ValidateEmailEpic = (
	action$: ActionsObservable<ActionType>,
	rootState$: StateObservable<RootState>
) =>
	action$.pipe(
		ofType(ValidateEmail.name),
		mergeMap((action) => {
			const body = action.payload;
			const clientId = get(rootState$.value, 'home.clientId', '');
			const captchaToken = get(rootState$.value, 'login.captchaToken', '');
			const nextView = get(rootState$.value, 'login.nextView', '');
			return from(
				axios({
					url: `${FORGOT_PIN}?client_id=${clientId}`,
					method: 'POST',
					data: body,
					headers: {
						'Content-Type': 'application/json',
						'X-Recaptcha-Token': captchaToken,
						Action: nextView
					}
				})
			).pipe(
				map((response: any) => ValidateEmail.successAction(response, action)),
				catchError((error: any) => of(ValidateEmail.failureAction(error, action)))
			);
		})
	);
